export default "__VITE_ASSET__B9e8rjDj__"